module.exports = __webpack_public_path__ + "img/photo.737a24c1.png";